import { Partnership } from './partnership.model';
import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Component, Injector } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { PartnershipService } from './partnership.service';
@Component({
  selector: 'ng-partnership',
  templateUrl: './partnership.component.html',
  styleUrls: ['./partnership.component.css']
})
export class PartnershipComponent extends BaseListComponent<Partnership>{
  protected initChildMethods(): void {}
  protected initChildProprieties(): void {}

  protected tableProprieties(): string[] {
    let columns= [
      'Parceiro',
      'Clube',
      'Serviço',
      'Descrição'
    ]

    if(this.isManager() || this.isUserClub()) {
      columns.splice(1,1)
    }

    return columns;
  }

  products: any[] = []
  loadingSpin: boolean = false

  constructor(
    public partnershipServ: PartnershipService,
    public injector: Injector,
    public auth:AuthService,
    public toastr: ToastrManager,
  ) {
    super(partnershipServ,injector,'partnership',{createUrl:'/admin/partnership/new',editUrl:'/admin/partnership/edit',detailUrl:'/admin/partnership/detail'});
   }

}
